upload:
  title_one: Upload Video
  title_other: Upload Videos
  fileReadFailed: "Failed to read file: {{ name }}"
  success: Video uploaded
  dropLabel_one: Drag & drop a video here
  dropLabel_other: Drag & drop videos here
  invalidType: Video files only
